"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _tslib = require("tslib");

var _react = _interopRequireWildcard(require("react"));

var _reactSpring = require("react-spring");

var _api = require("@lce/api");

var _i18n = require("@lce/i18n");

var _useCart = _interopRequireDefault(require("../../useCart"));

var Styled = _interopRequireWildcard(require("./CartIcon.style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

/* eslint-disable max-lines-per-function */
var CartIcon = function CartIcon() {
  var _a;

  var t = (0, _i18n.useTranslation)().t;
  var count = (0, _useCart["default"])().count;

  var _b = (0, _react.useState)(false),
      bagDrop = _b[0],
      setbagDrop = _b[1];

  var _c = (0, _react.useState)(undefined),
      prevCount = _c[0],
      setPrevCount = _c[1];

  var settings = (0, _api.useSettings)().data;
  var isAddToCartAnimationEnabled = (_a = settings === null || settings === void 0 ? void 0 : settings.FEATURE) === null || _a === void 0 ? void 0 : _a.ANIMATION_ADD_TO_CART_CONFIRMATION;
  (0, _react.useEffect)(function () {
    setPrevCount(undefined);
  }, []);
  (0, _react.useEffect)(function () {
    setPrevCount(count);
    prevCount !== undefined && count > prevCount && setbagDrop(true); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [count]);

  var _d = (0, _reactSpring.useSpring)({
    from: {
      y: bagDrop ? -25 : 0,
      opacity: bagDrop ? 1 : 0
    },
    to: {
      y: bagDrop ? 18 : 0,
      color: '#ffaaee',
      opacity: bagDrop ? 1 : 0
    },
    reset: true,
    reverse: false,
    loop: false,
    config: {
      tension: 150,
      friction: 12,
      precision: 2
    },
    onRest: function onRest() {
      setbagDrop(false);
    }
  }),
      opacity = _d.opacity,
      y = _d.y;

  var bagDropStyles = (0, _reactSpring.useSpring)({
    from: {
      y: 0
    },
    to: {
      y: isAddToCartAnimationEnabled && bagDrop ? 5 : 0
    },
    delay: 200,
    config: _reactSpring.config.wobbly
  });
  return _react["default"].createElement(Styled.SliceFlex, null, isAddToCartAnimationEnabled && _react["default"].createElement(_reactSpring.animated.div // eslint-disable-next-line react/forbid-component-props
  , {
    // eslint-disable-next-line react/forbid-component-props
    style: {
      opacity: opacity,
      y: y,
      position: 'absolute'
    }
  }, _react["default"].createElement(Styled.Coin, null)), _react["default"].createElement(_reactSpring.animated.div // eslint-disable-next-line react/forbid-component-props
  , {
    // eslint-disable-next-line react/forbid-component-props
    style: (0, _tslib.__assign)({}, bagDropStyles)
  }, _react["default"].createElement(Styled.CartIcon, {
    "data-testid": "header__mini-cart"
  }, _react["default"].createElement(Styled.Counter, {
    "aria-atomic": "true",
    "aria-live": "polite",
    "data-testid": "header__mini-cart-count"
  }, _react["default"].createElement(Styled.SrOnly, null, t('Header.Cart.Items In Cart')), count), _react["default"].createElement(Styled.ShoppingBag, {
    "aria-hidden": "true"
  }))));
};

var _default = CartIcon;
exports["default"] = _default;